module.exports = __webpack_public_path__ + "c05c3879.png";